'use strict';

angular.module('agentController', [])
.controller('AgentController', ['appInfo', '$scope', '$rootScope', '$window', '$location', '$log', '$q', '$routeParams', 'AgentService', 'PropertyService',
    function (appInfo, $scope, $rootScope, $window, $location, $log, $q, $routeParams, AgentService, PropertyService) {    
    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;
    $rootScope.loading = true;

    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , today = appInfo.today
    ;

    $scope.agent = {};
    $scope.agent.show = true;
    $scope.agent.header = 'display';
    $scope.agent.id = ($routeParams.id)? $routeParams.id : 0;

    var getProperty = function(listing) {
        PropertyService.getProperty(listing.listingRef).then(function(rs){
            var temp = {};
            
            if(rs[0].showOnWeb == "1"){
                temp.ref = listing.listingRef;
                temp.state = rs[0].propertyStateType;

                if(rs[0].showAddress == "1"){
                    temp.address = (rs[0].streetUnit!="")? 
                        rs[0].streetUnit+"/"+rs[0].streetRef+" "+rs[0].streetName+" "+rs[0].streetType+", "+rs[0].locationName :
                        rs[0].streetRef+" "+rs[0].streetName+" "+rs[0].streetType+", "+rs[0].locationName;
                } else {
                    temp.address = rs[0].locationName;
                }
                
                temp.suburb = rs[0].locationName;
                temp.priceView = rs[0].priceView;
                temp.thumb = rs[0].priceView;

                // Images --
                var images  = rs[0].marketing[0].images;
                temp.images = [];

                if(typeof images.img != 'undefined' && images.img.length){
                    angular.forEach(images.img, function(image){
                        temp.images.push(image);
                    }); 
                } else {
                    temp.images.push("http://dummyimage.com/800x533&text=Wiseberry");
                }
                
                // Heading & Description --
                temp.desc = rs[0].marketing[0].detail;
                temp.heading = rs[0].marketing[0].heading;

                $scope.agent.listings.push(temp);
            }
        });
    }

    AgentService.getAgent($scope.agent.id).then(function(response) {
        var rs = response.result[0];
        $scope.agent.name= rs.nameFirst+" "+rs.nameLast
        $scope.agent.agencies = rs.agency;

        angular.forEach(rs.info, function(value, key) {
            switch(key) {
                case "email":
                    $scope.agent.email = value;
                    break;
                case "bio":
                    $scope.agent.profile = value;
                    break;
                case "phone_-_mobile":
                    $scope.agent.mob = value;
                    break;
                case "photo":
                    $scope.agent.pic = value;
                    break;
                case "position":
                    $scope.agent.position = value;
                    break;
            }
        });

    }).finally(function(){
        AgentService.getAgentListings($scope.agent.id).then(function(response){
            var stats = response;

            if(stats.listings.length) {
                $scope.agent.listings = [];
                angular.forEach(stats.listings, function(listing){
                    getProperty(listing);
                });
            }
        }).finally(function(){
            $rootScope.loading = false;
        });
    });

    $window.scrollTo(0, angular.element('.agent').offsetTop);  

}]);